import React, { useContext, useEffect, useState } from 'react'
import organisms from '../../../../components/organisms'
import Wrapper from '../../../../components/common/Wrapper/Wrapper'
import service from '../../../../api/services'
import { useToasts } from 'react-toast-notifications'
import { useNavigate, useParams } from 'react-router'
import constant from '../../../../constants/constant'
import { HeaderHeading } from '../../../../Context'
import { useSearchParams } from 'react-router-dom'
import { findConstantLabel } from '../../../../constants/utils'
const { AddRoleOrg } = organisms

const AddRole = () => {
    const { addToast } = useToasts();
    const navigate = useNavigate()
    const { setHeader }: any = useContext(HeaderHeading);

    let params = useParams();
    let roleID: string = params.id || '';

    const [searchParams] = useSearchParams();
    const forParam: number  = Number(searchParams.get('assignedTo')) || NaN;

    const [roleError, setRoleError] = useState<any>({});
    const [structuredPermission, setStructuredPermission] = useState<any>([])
    const [rolesDetails, setRolesDetails] = useState<any>({
        role_name: '',
        role_for: '',
        permissions: []
    })
    const [defaultPermission, setDefaultPermission] = useState<any>([])

    // structure permission for admin portal
    const getStaffStructuredPermission = async () => {
        try {
            const response = await service.staff.structuredPermission()
            if (response.status === 200) {
                setStructuredPermission(response.data.data)
            }
        } catch (error) {
            console.error(error)
        }
    };
    // end

    // structure permission for store admin portal
    const getStoreStructuredPermission = async () => {
        const store_id:string = localStorage.getItem('store_id') || ''
        try {
            const response = await service.staff?.subAdminPermission(store_id)
            if (response.status === 200) {
                setStructuredPermission(response.data.data)
            }
        } catch (error) {
            console.error(error)
        }
    };
    // end
    const _handleSubmit = async () => {
        let payload = {
            role_name: rolesDetails.role_name,
            permissions: rolesDetails.permissions,
            role_for: rolesDetails?.role_for?.value
        }
        try {
            if (roleID) {
                const response = await service.roles.update(roleID, payload)
                if (response.status === 200) {
                    navigate(`/settings/role?role_for=${forParam}`)
                    addToast('Role Updated Successfully', {
                        appearance: 'success',
                        autoDismiss: true,
                        autoDismissTimeout: 3000,
                    });
                }
            } else {
                const response = await service.roles.add(payload)
                if (response.status === 201) {
                    navigate(`/settings/role?role_for=${forParam}`)
                    addToast('Role Added Successfully', {
                        appearance: 'success',
                        autoDismiss: true,
                        autoDismissTimeout: 3000,
                    });
                }
            }
        } catch (error: any) {
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }
    const getRolesData = async () => {
        try {
            const response = await service.roles.getById(roleID)
            if (response.status === 200) {
                handleStructurePermission(response?.data?.data?.roleDetails?.role_for)
                setRolesDetails({
                    role_name: response.data.data.roleDetails?.role_name,
                    permissions: response.data.data.permissions,
                    role_for: constant.ROLE_FOR.find((item) => item.value === response?.data?.data?.roleDetails?.role_for)
                })
                setDefaultPermission(response.data.data.permissions)
            }
        } catch (error) {

        }
    }
    const handleRoleChange = (e: { label: string, value: number, id: string }) => {
        setRolesDetails((prevState: any) => ({ ...prevState, role_for: e }));
        roleID && handleStructurePermission(e.value)
        setRoleError((prevState: any) => ({ ...prevState, role: '' }))
    }

    const handleChange = (name: string, value: any) => {
        setRolesDetails((prevState: any) => ({ ...prevState, [name]: value }));
    };
    const _handleCheckboxChange = (codeArr: []) => {
        setRolesDetails((prevState: any) => ({
            ...prevState,
            permissions: codeArr,
        }));
    };

    // handle submit
    const handleClick = () => {
        let error: any = {};
        if (
            rolesDetails?.role_name === undefined ||
            rolesDetails?.role_name === ""
        ) {
            error.name = "Please Enter Role Name";
        }
        if (!rolesDetails?.role_for?.value) {
            error.role_for = "Choose Specxweb, Store, or Staff Admin";
        }
        if (rolesDetails?.permissions?.length === 0) {
            error.role = "Please Select Permissions";
        }
        if (rolesDetails?.role_name && rolesDetails?.permissions?.length > 0) {
            _handleSubmit();
        }
        setRoleError(error);
    };
    // end

    // handle the render of structure permission
    const handleStructurePermission = (value: number | null) => {
        if (value === constant.ROLE_FOR[2].value) {
            getStaffStructuredPermission()
        } else {
            getStoreStructuredPermission()
        }
    }
    // end

    useEffect(() => {
        setHeader("Setting - Roles");
        roleID && getRolesData()
    }, [])

    useEffect(() => {
        if(forParam && !roleID){
            setRolesDetails((prevState: any) => ({
                ...prevState,
                role_for:{  
                    label: findConstantLabel(constant.ROLE_FOR, forParam), 
                    value: forParam, 
                    id: String(forParam)
                 },
            }));
         handleStructurePermission(forParam)
        }
    }, [forParam]);

    return (
        <Wrapper>
            <AddRoleOrg
                structuredPermission={structuredPermission}
                defaultPermission={defaultPermission}
                rolesDetails={rolesDetails}
                handleRoleChange={(e: { label: string, value: number, id: string }) => handleRoleChange(e)}
                roleError={roleError}
                handleChange={(name: string, value: any) => handleChange(name, value)}
                _handleCheckboxChange={(codeArr: []) => _handleCheckboxChange(codeArr)}
                handleClick={handleClick}
            />
        </Wrapper>
    )
}

export default AddRole